var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('Card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h4',{staticClass:"d-inline"},[_vm._v("مـــرکــز فایـــلـ")]),_c('hr')]},proxy:true},{key:"content",fn:function(){return [_c('EducationTable',{attrs:{"tablename":'File',"label":'موضوع فایل'}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }